import {Brand} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/brand.types';
import {SponsoredContentSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/sections.types';
import {
  desktopAndUpLinaria,
  FONT_WEIGHTS,
  mobileOnlyLinaria,
  SIZE,
  SponsoredWithBlurIcon,
  tabletAndDownLinaria,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {useSponsoredProductPopup} from '../../backend-services/SponsoredProductPopup/utils/useSponsoredProductPopup';
import {FollowBrand} from '../FollowBrand/FollowBrand';

export const SPONSORED_HEADER_SPACING_CSS_VAR = '--spacing';

export const SponsoredPlacementHeader: React.FC<{
  className?: string;
  brand?: Brand;
  hideFollowBrandLabel?: boolean;
  promotionTracking: SponsoredContentSection['promotionTracking'];
  sponsored?: SponsoredContentSection['sponsored'];
}> = ({
  className,
  brand,
  hideFollowBrandLabel,
  promotionTracking,
  sponsored,
}) => {
  const {onSponsoredClick} = useSponsoredProductPopup();

  return (
    <ButtonWrapper>
      {sponsored && (
        <StyledSponsored
          className={className}
          label={sponsored.label}
          onClick={e => {
            onSponsoredClick({e, promotionId: promotionTracking.promotionId});
          }}
          color="White"
          iconPosition="left"
        />
      )}
      {brand && (
        <StyledFollowBrand
          className={className}
          hideFollowBrandLabel={hideFollowBrandLabel}
          brand={{
            id: brand.id,
            name: brand.name,
            path: brand.path,
          }}
          promotionTracker={promotionTracking}
          iconSize="S"
        />
      )}
    </ButtonWrapper>
  );
};

const StyledSponsored = styled(SponsoredWithBlurIcon)`
  position: absolute;
  z-index: 1;
  top: 4px;
  left: 4px;

  --height: 24px;

  &&& {
    width: auto;
    height: var(--height);
  }

  ${tabletAndDownLinaria(`
    --height: 16px;
  `)}

  // make sure on mobile the sponsored icon have a touch-target area of 40px
  ${mobileOnlyLinaria(`
    --height: 44px;
    transform: translateY(-8px);
  `)}
`;

export const ButtonWrapper = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
`;

const StyledFollowBrand = styled(FollowBrand)`
  position: absolute;
  z-index: 1;
  top: 0;
  right: 8px;
  display: flex;
  gap: 4px;

  && {
    padding: 0;
  }

  > span {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    font-weight: ${FONT_WEIGHTS.mediumHeavy};
    text-shadow: 0px 0px 6px rgba(0, 0, 0, 0.2);
  }

  ${desktopAndUpLinaria(`
    right: ${SIZE.U3};
  `)}

  // make sure on mobile the sponsored icon have a touch-target area of 40px
  ${mobileOnlyLinaria(`
    height: 40px;
    transform: translateY(-8px);
  `)}
`;
